import { render, staticRenderFns } from "./HomesetFavors.vue?vue&type=template&id=634ae527&"
import script from "./HomesetFavors.vue?vue&type=script&lang=js&"
export * from "./HomesetFavors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports